module.exports = __webpack_public_path__ + "img/DW365-214.5723a78c.jpg";